'use client';

import { Navigation } from "@/components/navigation";
import { Footer } from "@/components/footer";
import { ChartGrid } from "@/components/chart-grid";
import { chartRegistry } from "@/config/chart-registry";
import { useState, useEffect } from "react";
import { decodeTimeframe } from "@/lib/url-encoding";

export default function AnalyticsPage() {
  const [initialTrim, setInitialTrim] = useState<string | null>(null);

  // Initialize trim from URL parameters
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const timeframeParam = urlParams.get('t');
      const timeframe = timeframeParam ? decodeTimeframe(timeframeParam) : null;
      
      setInitialTrim(timeframe);
    }
  }, []);
  return (
    <div className="min-h-screen">
      <Navigation />

      {/* Hero Section */}
      <section className="border-b border-border/40 py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl">
              On-Chain Analytics
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-muted-foreground">
              Real-time overview of the onchain ecosystem.
            </p>
            <p className="mx-auto max-w-2xl text-xs leading-8 text-muted-foreground">
              Charts on this page are updated daily.
            </p>
          </div>
        </div>
      </section>

      {/* Charts Section */}
      <section className="py-4 sm:py-8">
        <div className="container-fluid mx-auto">
          <div className="flex flex-col gap-6">
            {/* Chart Grid */}
            <div className={`
              flex-1 transition-all duration-300
            `}>
              <ChartGrid
                charts={chartRegistry.charts}
                initialTrim={initialTrim}
              />
            </div>

            {/* Sidebar */}
            {/* <ChartSidebar
              charts={chartRegistry.charts}
              presets={chartPresets.presets}
              selectedCharts={selectedCharts}
              onToggleChart={toggleChart}
              onSelectAll={selectAll}
              onDeselectAll={deselectAll}
              onApplyPreset={applyPreset}
            /> */}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

